export enum ContractMailTemplateType {
  contractSend = 'contract_send',
  contractReminder = 'contract_reminder'
}
